query xeroErrorsQuery($pagination: AdminListPagination!, $sort: AdminListSort!) {
  inventoryItemsWithXeroIssues(pagination: $pagination, sort: $sort) {
    data {
      ...inventoryItemsWithXeroIssuesItem
    }
  }
}



